<template>
  <v-app>
    <MapPage />
  </v-app>
</template>

<script>  
import MapPage from '@/components/views/MapPage'

export default {
  name: 'App',
  components: {
    MapPage
  },
  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
@import 'styles/_grid.scss';
@import 'styles/_typography.scss';
.v-application--wrap {
  overflow-x: hidden;
}
</style>